module.exports = __webpack_public_path__ + "img/yearly_customer_registration_count.56774511.svg";